<template>
  <div>
    <header class="entete mgb-20px">
      <div class="level" v-if="!detail">
        <div class="level-left"></div>
        <div class="level-right">
          <button class="button is-addOrEdit" @click="addCompetence()">
            {{ $t('addEditFournisseurs.competences.addCompetence')}}
          </button>
        </div>
      </div>
    </header>
    <v-client-table
      v-model="fournisseur.competencesFournisseur"
      :columns="columns"
      :options="options"
      :ref="referenceTable">
      <template #libelle="{ row }">
        {{ row.competenceFournisseur.libelle }}
      </template>
      <template #delete="{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="perm.maj"
            @is-click="deleteCompetence(row)"
            icon-type="is-danger"
            icon="delete-forever">
          </btn-action-icon>
        </div>
      </template>
    </v-client-table>
    <b-modal
      :active="popUpAddCompetence"
      @close="popUpAddCompetence = false"
      class="modal"
      width="600px"
      has-modal-card>
      <p-add-competence :fournisseur="fournisseur"/>
    </b-modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { columnsSplice } from '@/services/general/columns';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { FOURNISSEURS } from '@/configuration/achat/permissionsConf';
import { REFERENCE_TABLE_COMPETENCES_FOURNISSEUR } from '@/configuration/general/referenceTableConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import PAddCompetence from '@/components/achat/fournisseurs/addEdit/competencesTab/p_addCompetence';

export default {
  name: 'CompetencesTab',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    BtnActionIcon,
    PAddCompetence,
  },
  data() {
    return {
      perm: FOURNISSEURS,
      referenceTable: REFERENCE_TABLE_COMPETENCES_FOURNISSEUR,
      popUpAddCompetence: false,
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'libelle', sortable: true },
        { name: 'delete', sortable: false },
      ];
    },
    columns() {
      const columns = this.columnsData.map((column) => column.name);
      if (this.detail) {
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, column) => {
        const key = `addEditFournisseurs.competences.table.${column.name}`;
        acc[column.name] = this.$te(key) ? this.$t(key) : '';
        return acc;
      }, {});
      const sortable = !this.detail
        ? this.columnsData
          .filter((column) => column.sortable)
          .map((column) => column.name)
        : [];
      return {
        texts,
        headings,
        sortable,
        sortIcon: SORT_ICON,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        columnsClasses: {
          delete: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    addCompetence() {
      this.popUpAddCompetence = true;
    },
    deleteCompetence(row) {
      const { competencesFournisseur } = this.fournisseur;
      this.fournisseur.competencesFournisseur = competencesFournisseur.filter(el => {
        return el.competenceFournisseurId !== row.competenceFournisseurId;
      });
    },
  },
};
</script>
